import React from 'react'
import { Link } from "react-router-dom";
function HeadmistressMessage() {
    return (
        <>
            {/* <div className="innerslide py-3 bg-light border-bottom">
                <ul className="breadcrumb container mb-0">
                    <li className="breadcrumb-item">
                        <Link to="/">Home</Link>
                    </li>{" "}
                    <li className="breadcrumb-item active"> Leadership</li>
                    <li className="breadcrumb-item active"> Headmistress's Message </li>
                </ul>
            </div>
            <div className="innersec container my-5 founder_message">
                <div className="row">
                    <div class="col-lg-12">
                        <h1> Headmistress's Message</h1>
                    </div>
                    <div className="col-lg-12">
                        <>
                            <img
                                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/Jean_Ireland.JPG"
                                className="col-md-4 float-md-end left-img img-fluid"
                                alt="thefrankanthonyjuniorschoolblr" />
                            <p>
                                coming soon...
                            </p>
                            <br />
                            <div className="mesdeskimg">
                                <h3> Miss Jean Elizabeth Andrea Ireland</h3>
                                <h5>Headmistress </h5>
                            </div>
                        </>
                    </div>
                </div>
            </div> */}
        </>
    )
}

export default HeadmistressMessage